<ng-template #template let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="exampleModalgridLabel">{{ "heading-title.add-card" | translate }}</h5>
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
    </div>
    <div class="modal-body">
      <div class="row gy-3">
        <div class="col-md-12 mt-0">
          <label for="cc-number" class="form-label">{{ "label-title.card-number" | translate | titlecase }}</label>
          <div class="form-control" id="cc-number"></div>
          <div id="number-errors" class="invalid-message"></div>
        </div>

        <div class="col-md-6">
          <label for="cc-expiration" class="form-label">
            {{ "label-title.expiration-date" | translate | titlecase }}
          </label>
          <div class="form-control" id="cc-expiration"></div>
          <div id="expiration-errors" class="invalid-message"></div>
        </div>

        <div class="col-md-6">
          <label for="cc-cvv" class="form-label">{{ "label-title.cvv" | translate | titlecase }}</label>
          <div class="form-control" id="cc-cvv"></div>
          <div id="cvv-errors" class="invalid-message"></div>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <button
          id="update-city-boundry"
          class="btn btn-sm btn-secondary btn-load mt-3 d-flex align-items-center justify-content-center"
          style="overflow: unset"
          (click)="saveCard()"
          [ngClass]="{ 'pointer-events-none': helper.showBtnLoader[1] }"
        >
          <span class="d-flex align-items-center">
            @if (helper.showBtnLoader[1]) {
            <span class="spinner-border flex-shrink-0">
              <span class="visually-hidden"></span>
            </span>
            } @else {
            <span class="flex-grow-1" [ngClass]="{ 'ms-2': helper.showBtnLoader[1] }">
              {{ "button-title.save" | translate }}
            </span>
            }
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>
